function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "25",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_402_12031)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 1c-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6-2.692-6-6-6zm2.55 6.45h-2.1v2.1a.45.45 0 11-.9 0v-2.1h-2.1a.45.45 0 110-.9h2.1v-2.1a.45.45 0 11.9 0v2.1h2.1a.45.45 0 110 .9z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.37 4.749L9.832 3.63a.69.69 0 00-.81 0L.284 9.981a.69.69 0 00-.25.77L3.37 21.023a.69.69 0 00.656.477h10.8a.69.69 0 00.657-.477l2.283-7.027a7.001 7.001 0 01-1.39-.185l-2.05 6.31H4.527L1.5 10.8l7.927-5.758 1.616 1.174c.057-.508.168-1 .327-1.468z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_402_12031"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .75)",
  d: "M0 0h24v24H0z"
})))));